import React, {useEffect, useState} from 'react'
import BottomToTop from '../../../../components/transitions/bottom-to-top'
import RightLeft from '../../../../components/transitions/right-to-left'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'
import ListVideos from './list-videos/normal-list'

const FixedWindow = props => {
    useStyles(classes)
    const { show, onClose, videos, listVideoClickHandle } = props

    return <RightLeft unmountOnExit in={show} className={classes.ListingVideoPage}>
        <div>
           <div className={classes.Hd}>
                 <span className={classes.Title}>Item Show</span>
                 <Iconfont className={classes.Close} onClick={onClose}>&#xe693;</Iconfont>
           </div>
           <div className={classes.Bd}>
                <ListVideos listVideoClickHandle={listVideoClickHandle} videos={videos}/>
           </div>
        </div>
    </RightLeft>
}

export default props => {
    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <FixedWindow {...props} />,
        document.getElementById('root')
    )
}